import React from "react"
import PropTypes from "prop-types"
import axios from "axios"

class NewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {visible: this.props.data.visible};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    var self = this;
    let itemId = this.props.data.id;
  	axios({
	   method: "POST", 
	   url: "/view",
	   data: {id: itemId}
	  })
    .then(function(response){
      if (response.status == 200){
        self.setState(prevState => ({
          visible: !prevState.visible
        }));
        self.props.updateData(self.state.visible);
      } else {
      }
    })
    .catch(function(error){
      console.log("Error blyat!")
    });
    
  }


  render () {
    return (
    	<a className="media-button btn-new" onClick={this.handleClick}>
         <i className="far fa-eye-slash"></i> Скрыть
      </a>
    );
  }
}

export default NewButton
